import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStarAnimate = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.96284 6C1.96284 5.72386 2.1867 5.5 2.46284 5.5H5.33464C5.61078 5.5 5.83464 5.72386 5.83464 6C5.83464 6.27614 5.61078 6.5 5.33464 6.5H2.46284C2.1867 6.5 1.96284 6.27614 1.96284 6ZM0.167969 8.96296C0.167969 8.68682 0.391826 8.46296 0.667969 8.46296H5.33464C5.61078 8.46296 5.83464 8.68682 5.83464 8.96296C5.83464 9.23911 5.61078 9.46296 5.33464 9.46296H0.667969C0.391826 9.46296 0.167969 9.23911 0.167969 8.96296ZM3.39874 11.3333C3.39874 11.0572 3.6226 10.8333 3.89874 10.8333H5.33464C5.61078 10.8333 5.83464 11.0572 5.83464 11.3333C5.83464 11.6095 5.61078 11.8333 5.33464 11.8333H3.89874C3.6226 11.8333 3.39874 11.6095 3.39874 11.3333Z",
			fill: "#545F7E"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.6347 4.37756C12.5922 3.62853 11.6186 3.36766 11.2074 3.99512L9.99128 5.85045C9.86935 6.03647 9.64181 6.12326 9.42697 6.0657L7.25997 5.48505C6.52945 5.28931 5.97749 6.14564 6.45743 6.73013L7.86161 8.4402C8.0046 8.61435 8.01786 8.8612 7.89433 9.04966L6.68987 10.8872C6.27732 11.5167 6.90991 12.3067 7.61432 12.0418L9.71747 11.2509C9.92399 11.1732 10.157 11.2357 10.2971 11.4062L11.723 13.1427C12.2006 13.7244 13.1434 13.3564 13.1009 12.6051L12.9766 10.4114C12.9638 10.1865 13.0987 9.97931 13.3096 9.89999L15.3807 9.12112C16.0886 8.8549 16.0388 7.83732 15.3082 7.64158L13.1412 7.06093C12.9264 7.00336 12.7727 6.81444 12.7602 6.59237L12.6347 4.37756Z",
			fill: "#545F7E"
		})
	]
});
const ForwardRef = forwardRef(SvgStarAnimate);
export default ForwardRef;
